export const iconFontAwesomeEmojiFaceGrinStars = (
	<i className="fa-solid fa-face-grin-stars"></i>
);
